// get the keys to use for selection based on the type of item being hovered (bar, legend item, etc)
  // move the default handlers to their own file
  export const checkIfSelected = ((x?: Record<string, unknown>, selected?: Record<string, unknown>): boolean | undefined => {  
    const { x_key,  bar, slice, legend,  legend_key } = x || {}
 
    let is_selected = undefined as boolean | undefined
    if (!selected) return is_selected
   
    if (bar) {
      let selected_x = selected?.[x_key as string]
      if (selected_x) {
        is_selected = false
        if (!Array.isArray(selected_x)) selected_x = [selected_x]
        selected_x?.forEach((v: string) => {
          if (String(x?.[x_key as string]).toLowerCase() === String(v).toLowerCase()) is_selected = true
        }) 
      }  
    }

    if (slice || legend) {
      const grouping_key = x?.grouping_key || x?.props?.grouping_key || legend_key || x?.props?.legend_key
      let selected_group = selected?.[grouping_key as string]
      if (!selected_group) return undefined
      const group = x?.[grouping_key]      
      let is_selected = false
      if (!Array.isArray(selected_group)) selected_group = [selected_group]
      selected_group?.forEach((v: string) => {
       if (String(group).toLowerCase() === String(v).toLowerCase()) is_selected = true
      }) 
      return is_selected
    }
    
    return is_selected
  })


  export const checkIfFiltered = ((x?: Record<string, unknown>, selected?: Record<string, unknown>): boolean | undefined => {
    const { x_key,  bar, slice, legend, legend_key } = x || {}
    let is_filtered = undefined as boolean | undefined
    if (bar) return is_filtered
    if (!selected) return is_filtered

    let selected_x = selected?.[x_key as string]
    if (selected_x) {
      is_filtered = false
      if (!Array.isArray(selected_x)) selected_x = [selected_x]
      selected_x?.forEach((v: string) => {
        if (String(x?.[x_key as string]).toLowerCase() === String(v).toLowerCase()) is_filtered = false
      }) 
    }  

    if (slice || legend) {
      const grouping_key = x?.grouping_key || x?.props?.grouping_key || legend_key || x?.props?.legend_key
      
      let selected_group = selected?.[grouping_key as string]
      let is_selected = false
      if (!Array.isArray(selected_group)) selected_group = [selected_group]
      selected_group?.forEach((v: string) => {
        if (String(x?.[x_key as string]).toLowerCase() === String(v).toLowerCase()) is_selected = true
      }) 
      return is_selected
    }
  
    return is_filtered
  })

  export const handleClick = ((x?: Record<string, unknown>, states?: [Record<string, unknown>, (selected?: Record<string, unknown>) => void] | undefined): void => {
    const  [selected, setSelected] = states || []
    const { bar, x_key, legend, slice, legend_key } = x || {}
    const x_val = x?.[x_key as string]
    const selected_x_vals = selected?.[x_key as string]
    
    if (bar) {
      const is_selected = checkIfSelected?.(x, selected)
      if (!is_selected) return setSelected?.({ [x_key as string]: [x_val] })
      let new_selectedx_vals = selected_x_vals?.filter((v: string) => v !== String(x_val)) || []
      if (new_selectedx_vals?.length === 0) new_selectedx_vals = undefined
      return setSelected?.({ ...(selected || {}), [x_key as string]: new_selectedx_vals }) 
    }
 

    if (slice || legend) {
      const grouping_key = x?.grouping_key || x?.props?.grouping_key || legend_key || x?.props?.legend_key
      const group = x?.[grouping_key]
      const current = (selected?.[grouping_key as string] || []) as Array<string | number | Date>
      const selectedList = Array.isArray(current) ? current : [current].filter(Boolean)
      const hasGroup = selectedList.some((value) => String(value).toLowerCase() === String(group).toLowerCase())

      if (!selected || !selected?.[grouping_key]) {
        return setSelected?.({ ...(selected || {}), [grouping_key as string]: [group] })
      }

      if (!hasGroup) {
        return setSelected?.({ ...(selected || {}), [grouping_key as string]: [...selectedList, group] })
      }

      const nextSelected = selectedList.filter((value) => String(value).toLowerCase() !== String(group).toLowerCase())
      return setSelected?.({ ...(selected || {}), [grouping_key as string]: nextSelected.length ? nextSelected : undefined })
    }

  })